import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../../uikit/info/Modal';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { mainFormSlice } from '../../../../store/mainForm/mainForm.slice';
var t = getTranslation(translations);
var mapDispatchToProps = function (dispatch) { return ({
    restartSession: function () { return dispatch(mainFormSlice.actions.restartSession()); },
}); };
export function RawLeadIsSubmittedModal(_a) {
    var isOpen = _a.isOpen, restartSession = _a.restartSession;
    var actions = useMemo(function () { return [
        {
            title: t.buttonTitle,
            onClick: restartSession,
            variant: 'contained',
            size: 'large',
        },
    ]; }, [restartSession]);
    return (React.createElement(Modal, { actions: actions, open: isOpen }, t.content));
}
export default connect(null, mapDispatchToProps)(RawLeadIsSubmittedModal);
